/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import RateList from "./RateList";
import SetPasswordContainer from "../../containers/lk/SetPasswordContainer";
import Diagramma from "./diagramma/Diagramma";
import LKProfile from "./LKProfile";
import LKSchedule from "./LKSchedule";
import LKLinks from "./LKLinks";
import usePageWidth from "../shared/usePageWidth";
import styles from "./LK.module.css";

export default function LK(props) {
  const {
    links,
    isTeacher,
    user,
    history,
    selfPhoto,
    rateList,
    mid,
    unreadMessages,
    unreadAnnouncements,
    needChangePassword,
    didMount,
    scheduleToday,
  } = props;

  // Оболочка тянется по ширине окна (см. shared/usePageWidth.js). Без этого
  // .main-content держит 1100px и на окне 800x600 страница уезжает вбок,
  // а сетка ЛК, перестроенная медиазапросами, всё равно рисуется на 1100px.
  usePageWidth('pageWide');

  const [isModalVisible, setIsModalVisible] = useState(needChangePassword || false);

  const profileRef = useRef(null);
  const [syncedHeight, setSyncedHeight] = useState(null);
  // Порог тот же, что у сетки в LK.module.css: выше 1024 колонки стоят в ряд
  const [isThreeCol, setIsThreeCol] = useState(() => window.innerWidth > 1024);

  useEffect(() => {
    didMount();
    window.scrollTo(0, 0);
  }, []);

  // без слушателя рамка высоты, снятая с профиля, оставалась бы на секциях
  // после сужения окна — расписание и ссылки обрезались бы в один-два ряда
  useEffect(() => {
    const onResize = () => setIsThreeCol(window.innerWidth > 1024);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Секции расписания и ссылок подстраиваются по высоте под профиль
  useEffect(() => {
    const el = profileRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setSyncedHeight(entry.contentRect.height);
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const syncedStyle =
    syncedHeight && isThreeCol
      ? { height: `${syncedHeight}px`, overflow: "hidden" }
      : {};

  const showModal = (visible) => () => {
    !needChangePassword && setIsModalVisible(visible);
  };

  return (
    <div className={styles.page}>
      {/* заголовок держим в той же колонке, что и карточки: оболочка теперь
          шире 1400px, и без обёртки он уезжал бы к краю окна */}
      <div className={styles.pageHead}>
        <div className="captions h1">Личный кабинет</div>
      </div>

      <div className={styles.grid}>
        <div className={styles.colProfile} ref={profileRef}>
          <LKProfile
            user={user}
            isTeacher={isTeacher}
            selfPhoto={selfPhoto}
            unreadMessages={unreadMessages}
            unreadAnnouncements={unreadAnnouncements}
            history={history}
            onChangePassword={showModal(true)}
          />
        </div>

        <div className={`${styles.syncedCol} ${styles.colSchedule}`} style={syncedStyle}>
          <LKSchedule scheduleToday={scheduleToday} />
        </div>

        <div className={`${styles.syncedCol} ${styles.colLinks}`} style={syncedStyle}>
          <LKLinks links={links} isTeacher={isTeacher} />
        </div>
      </div>

      {!isTeacher && !!rateList.length && (
        <div className={styles.ratingsGrid}>
          {rateList.map((elem, i) => (
            <RateList key={i} elem={elem} mid={mid} />
          ))}
        </div>
      )}

      {!isTeacher && <Diagramma isTeacher={isTeacher} photoForRadar={selfPhoto} />}

      {isModalVisible && (
        <SetPasswordContainer
          isModalVisible={isModalVisible}
          onRequestClose={showModal(false)}
        />
      )}
    </div>
  );
}
